"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var buffer_1 = require("buffer");
var paste_1 = require("../pastes/paste");
var codefile_1 = require("../pastes/codefile");
var pastefile_1 = require("../pastes/pastefile");
var PasteParserV2 = /** @class */ (function () {
    function PasteParserV2() {
    }
    PasteParserV2.prototype.parse = function (name, key, pasteData) {
        var paste = new paste_1.default(name, key);
        paste.files = pasteData.files.map(function (f, i) {
            if (typeof f.data !== 'string') {
                throw new Error("Unsupported data type in V2 Paste.");
            }
            if (codefile_1.default.isReadable(f.meta.mime)) {
                return new codefile_1.default(i, f.name, buffer_1.Buffer.from(f.data, 'base64').toString(), f.meta.highlight);
            }
            return new pastefile_1.default(i, f.name, f.data, f.meta.mime);
        });
        return paste;
    };
    return PasteParserV2;
}());
exports.default = PasteParserV2;
